$(function () {
	'use strict';


	var initialize = function (parentWindow) {
		parentWindow = $(parentWindow || 'body');
		var scroller = parentWindow.is(window.body) ? $(window) : parentWindow;

		var me = this,
			sections = parentWindow.find('.section'),
			navBlock = parentWindow.find('.nav-block').first(),
			navRoots = parentWindow.find('.nav--link'),
			navLinks = parentWindow.find('.nav-section > a'),
			cmdBar = parentWindow.find('.ts-commands-bar').first(),

			scrollNavContainer;

		var topOffsetKeyName = 'top-offset',
			margin = 0,
			navScroll = false,
			scrollLimit = 155,                      // when to start pinning the sidebar navigation block & view commands
			spacing = 10,                           // vertical space between the commands and document
			sectionHeight = 41,
			navBlockMinHeight,

			offsetDelta = 58,
			prevId,
			clickedAt,
			scrollAnimationDuration = 100,
			delay = scrollAnimationDuration + 200,
			onScrollHandler,
			onResizeHandler,
			neededNavBlockHeight,
			updateNavBlockHeight,
			prevNavBlockAvailableHeight;


		var parentOffset = parentWindow.offset() || {};
		// detect command bar top position & height
		if (cmdBar.length) {
			if (cmdBar.offset() && cmdBar.offset().top) {
				scrollLimit = cmdBar.offset().top - (parentOffset.top || 0);
			}
			if (cmdBar.height()) {
				offsetDelta = cmdBar.height() + 10;
			}
		}
		// correlated with CSS media queries
		if (screen.height <= 768) {
			spacing = 5;
		}

		$.each(sections, function (index, section) {
			$.data(section, topOffsetKeyName, $(section).offset().top - (parentOffset.top || 0));
		});

		navLinks.click(function (e) {
			var $a = $(this),
				href = $a.attr('href'),
				id = href.substr(1),
				section,
				offsetTop;

			// remember when user clicked - ignore active section detection in scroll handler
			clickedAt = new Date();
			section = parentWindow.find('#' + id);
			offsetTop = section.length ? $.data(section[0], topOffsetKeyName) : 0;
			if (offsetTop > scrollLimit + offsetDelta)
			    offsetTop -= 2 * offsetDelta; //first because cmdBar is floating, second is because we have to the section under the floating top cmdBar

			var elemToScroll = parentWindow.parent('html').add(parentWindow);
			elemToScroll.stop().animate({
				scrollTop: offsetTop
			}, scrollAnimationDuration, undefined, function () {
				navLinks.parent().removeClass('active');
				$a.parent().addClass('active');
			});

			e.preventDefault();
		});

		$.scrollUp({
			scrollName: 'scrollUp',         // Element ID
			scrollDistance: scrollLimit,    // Distance from top/bottom before showing element (px)
			scrollFrom: 'top',              // 'top' or 'bottom'
			scrollSpeed: 300,               // Speed back to top (ms)
			easingType: 'linear',           // Scroll to top easing (see http://easings.net/)
			animation: 'fade',              // Fade, slide, none
			animationInSpeed: 200,          // Animation in speed (ms)
			animationOutSpeed: 200,         // Animation out speed (ms)
			scrollText: 'Scroll to top',    // Text for element, can contain HTML
			scrollTitle: false,             // Set a custom <a> title if required. Defaults to scrollText
			scrollImg: true,                // Set true to use image
			activeOverlay: false,           // Set CSS color to display scrollUp active point, e.g '#00FFFF'
			zIndex: 2147483647              // Z-Index for the overlay
		});

		navRoots.tooltip();

		updateNavBlockHeight = function () {
			var wH, navBlockAvailableHeight, scrollNavAvailableHeight;

			// nav block height without the sub nav links
			wH = scroller.height();
			navBlockAvailableHeight = wH + scroller.offset().top - navBlock.offset().top + scroller.scrollTop() - spacing;

			if (prevNavBlockAvailableHeight === navBlockAvailableHeight)
				return;

			// if previous height and current height are bigger than the needed height there is no change
			if (Math.min(prevNavBlockAvailableHeight, navBlockAvailableHeight) >= neededNavBlockHeight)
				return;

			prevNavBlockAvailableHeight = navBlockAvailableHeight;

			if (navBlockAvailableHeight < neededNavBlockHeight) {
				/*navScroll = true;
				navBlock.height(navBlockAvailableHeight);

				scrollNavAvailableHeight = navBlockAvailableHeight - navBlockMinHeight;
				scrollNavContainer.slimScroll({destroy: true});
				scrollNavContainer.slimScroll({
					alwaysVisible: true,
					disableFadeOut: true,
					height: scrollNavAvailableHeight + 'px'
				});
				// force height change (slim scroll does not update)
				scrollNavContainer.css('height', scrollNavAvailableHeight + 'px');
				scrollNavContainer.parent().css('height', scrollNavAvailableHeight + 'px');*/
				navBlock.css('min-height', neededNavBlockHeight);
			} else {
				navScroll = false;

				// diry way to check if the slim scroll is set (avoids a scroll flickering if already disposed)
				if (scrollNavContainer.css('height') !== 'auto') {
					scrollNavContainer.slimScroll({ destroy: true });
				}
				scrollNavContainer.css('height', 'auto');
				scrollNavContainer.parent().css('height', 'auto');
				navBlock.css("height", "auto").css("display", "block");
			}

			scrollNavContainer.show();
		};

		onResizeHandler = function () {
			updateNavBlockHeight();
		};

		onScrollHandler = function (e) {
			var curSec, id,
				scrollTop;

			scrollTop = scroller.scrollTop();

			// find sections above current scroll position
			curSec = $.map(me.getSections(), function (s) {
				if ($(s).offset().top - sectionHeight < scrollTop)
					return s;
			});

			// get the last one (or the first if none matches)
			curSec = curSec[curSec.length - 1] || sections[0];
			id = curSec ? curSec.id : '';

			if (id != prevId) {
				prevId = id;

				if (!clickedAt || new Date().getTime() - clickedAt > delay) {
					navLinks.parent().removeClass('active');
					var target = navLinks.filter('[href=#' + id + ']').parent();
					target.addClass('active');

					if (navScroll) {
						var cntST = scrollNavContainer.prop('scrollTop');
						var cntCH = scrollNavContainer.prop('clientHeight');
						var targetH = target.height();
						var targetT = target.prop('offsetTop');

						if (targetT > cntST + cntCH - targetH) {
							scrollNavContainer.slimScroll({
								scrollTo: (targetT + targetH + 5 - cntCH) + 'px',
								alwaysVisible: true,
								disableFadeOut: true
							});
						} else if (targetT < cntST) {
							scrollNavContainer.slimScroll({
								scrollTo: (targetT) + 'px',
								alwaysVisible: true,
								disableFadeOut: true
							});
						}
					}
				}
			}
			updateNavBlockHeight();
		};

		if (navBlock.length) {
			scrollNavContainer = parentWindow.find('#scrollNavContainer').filter(function () {
				var element = $(this);

				if (element.css('display') == 'none') {
					element.remove();
					return false;
				}

				return true;
			});

			neededNavBlockHeight = navBlock.actual('height');
			scrollNavContainer.hide();
			navBlockMinHeight = navBlock.height();

			setTimeout(function () {
				onScrollHandler();
				scroller.on('scroll', onScrollHandler);
				scroller.resize(onResizeHandler);
			}, 10)
		}
		;
	};

	TS.scrollNav = {
		getSections: function () {
			return $('.section');
		},

		initialize: initialize,

		getSectionClass: function (section) {
			return TS.unwrap(section.Selected) ? 'nav-section active' : 'nav-section';
		},

		getRootClass: function (root) {
			var result = TS.unwrap(root.Selected) ? 'nav-root active' : 'nav-root';
			result += TS.unwrap(root.Enabled) ? '' : ' disabled';
			return result;
		},

		getSectionContainerId: function (root) {
			return (TS.unwrap(root.Sections).length > 0) ? 'scrollNavContainer' : '';
		}
	};


	var tsNavBlockRoots = 'tsNavBlockRoots',
		tsNavBlockRoot = 'tsNavBlockRoot',
		tsNavBlockSections = 'tsNavBlockSections',
		tsNavBlockSection = 'tsNavBlockSection';

	(function () {
		function getBindingValue(roots, options) {
			var result = [],
				rootsValue = TS.unwrap(roots || []);
			options = options || {};
			$.each(rootsValue, function (index, item) {
				var itemOptions = options[TS.unwrap(item.Name)] || {};
				result.push({
					property: item,
					sections: itemOptions.sections,
					text: itemOptions.text || item.Text,
					enabled: itemOptions.enabled || item.Enabled,
					visible: itemOptions.visible || item.Visible
				});
			});
			return result;
		}

		function setupNavBlockAccessor(element, value, allBindings, viewModel, bindingContext) {
			var accessorValue = {},
				roots = bindingContext.$data[value.dataSource].Roots,
				bindingValue = accessorValue['foreach'] = ko.observableArray(getBindingValue(roots, value.roots)),
				accessor = function () {
					return accessorValue;
				};

			accessorValue['as'] = tsNavBlockRoot;
			//set template engine
			accessorValue.templateEngine = ko.nativeTemplateEngine.instance;

			var subscription = roots.subscribe(function (newValue) {
				bindingValue(getBindingValue(roots, value.roots));
				ko.bindingHandlers['template']['update'](element, accessor, allBindings, viewModel, bindingContext);
			});
			ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
				subscription.dispose();
				subscription = null;
			});

			return accessor;
		}

		ko.bindingHandlers[tsNavBlockRoots] = {
			'init': function (element, valueAccessor, allBindings, viewModel, bindingContext) {
				var value = valueAccessor() || {},
					accessor = setupNavBlockAccessor(element, value, allBindings, viewModel, bindingContext);
				var result = ko.bindingHandlers['template']['init'](element, accessor);
				ko.bindingHandlers['template']['update'](element, accessor, allBindings, viewModel, bindingContext);
				return result;
			}
		};
		ko.expressionRewriting.bindingRewriteValidators[tsNavBlockRoots] = false; // Can't rewrite control flow bindings
		ko.virtualElements.allowedBindings[tsNavBlockRoots] = true;


		ko.bindingHandlers['tsNavRoot'] = {
			init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {

				var navBlockRoot = valueAccessor(),
					enabledBinding = allBindings.get('enabled'),
					domain = bindingContext.$root,
					eventName = 'click';

				if (enabledBinding) {
					enabledBinding.subscribe(function (newValue) {
						ko.utils.toggleDomNodeCssClass(element, 'disabled', newValue === false);
					});
				}

				if (TS.unwrap(navBlockRoot.Selected)) {
					return null;
				}

				var cmdCode = navBlockRoot && TS.unwrap(navBlockRoot.CommandCode);
				if (!cmdCode) {
					TS.Log.warn('NavRoot [' + navBlockRoot.Name() + '] has no command assigned');
					return null;
				}

				var newValueAccessor = function () {
					var result = {};
					result[eventName] = function () {
						try {
							domain.executeCommand(cmdCode);
						}
						catch (ex) {
							TS.Notify.error('Error executing command ' + cmdCode + ', error: ' + ex.message);
						}
					};
					return result;
				};

				return ko.bindingHandlers['event']['init'].call(this, element, newValueAccessor, allBindings, viewModel, bindingContext);
			},

			update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {

				var navBlockRoot = valueAccessor();

				ko.bindingHandlers['css'].update(element, function () {
					return navBlockRoot.Selected() ? 'active' : '';
				}, allBindings, viewModel, bindingContext);
			}
		};
	})();


	(function () {

		function getBindingValue(sections, options) {
			var result = [],
				sectionsValue = TS.unwrap(sections || []);
			options = options || {};
			$.each(sectionsValue, function (index, item) {
				var itemOptions = options[TS.unwrap(item.Name)] || {};
				result.push({
					property: item,
					text: itemOptions.text || item.Text,
					enabled: itemOptions.enabled || item.Enabled,
					visible: itemOptions.visible || item.Visible
				});
			});
			return result;
		}

		function setupNavBlockSectionAccessor(element, value, allBindings, viewModel, bindingContext) {

			var accessorValue = {},
				sections = value.property.Sections,
				bindingValue = accessorValue['foreach'] = ko.observableArray(getBindingValue(sections, value.sections)),
				accessor = function () {
					return accessorValue;
				};

			accessorValue['as'] = tsNavBlockSection;
			//set template engine
			accessorValue.templateEngine = ko.nativeTemplateEngine.instance;

			var subscription = sections.subscribe(function (newValue) {
				bindingValue(getBindingValue(sections, value.sections));
				ko.bindingHandlers['template']['update'](element, accessor, allBindings, viewModel, bindingContext);
			});
			ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
				subscription.dispose();
				subscription = null;
			});

			return accessor;
		}

		ko.bindingHandlers[tsNavBlockSections] = {
			'init': function (element, valueAccessor, allBindings, viewModel, bindingContext) {
				var value = valueAccessor() || {},
					accessor = setupNavBlockSectionAccessor(element, value, allBindings, viewModel, bindingContext);
				var result = ko.bindingHandlers['template']['init'](element, accessor);
				ko.bindingHandlers['template']['update'](element, accessor, allBindings, viewModel, bindingContext);
				return result;
			}
		};
		ko.expressionRewriting.bindingRewriteValidators[tsNavBlockSections] = false; // Can't rewrite control flow bindings
		ko.virtualElements.allowedBindings[tsNavBlockSections] = true;

		ko.bindingHandlers['tsNavSection'] = {
			init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
			},

			update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {

			}
		};
	})();
});